import styled from 'styled-components'
import Colors from '../../../../themes/Colors'

const AdsFiltersPanelHolder = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  padding: 16px;
  background: ${Colors.snow};
  border: 1px solid ${Colors.border};
  border-radius: 6px;
  overflow: hidden;

  &.filters-panel-enter {
    opacity: 0;
    max-height: 0;
    transform: translateY(-8px);
  }
  &.filters-panel-enter-active {
    opacity: 1;
    max-height: 200px;
    transform: translateY(0);
    transition: opacity 0.25s ease, max-height 0.25s ease, transform 0.25s ease;
  }
  &.filters-panel-exit {
    opacity: 1;
    max-height: 200px;
    transform: translateY(0);
  }
  &.filters-panel-exit-active {
    opacity: 0;
    max-height: 0;
    transform: translateY(-8px);
    transition: opacity 0.25s ease, max-height 0.25s ease, transform 0.25s ease;
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 0 0 200px;

    label {
      font-size: 12px;
      color: ${Colors.textMuted};
    }

    .ant-select {
      width: 200px;
    }
  }

  .apply-button {
    min-width: 120px;
    margin-left: auto;
  }
`

export default AdsFiltersPanelHolder
